import { useAppState } from 'AppProvider';
import InfoCircleIcon from 'assets/bx-info-circle';
import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  width: 100%;
  padding-bottom: 16px;
`;

const IconContainer = styled.div`
  margin-right: 10px;
`;

const Header = styled.div.withConfig({
  shouldForwardProp: (prop) => !['variantColor'].includes(prop),
})<{ variantColor: string }>`
  color: ${(p) => p.variantColor};
  margin-bottom: 8px;
`;

interface AlertProps {
  children?: React.ReactNode;
  heading: string;
  variant?: 'info' | 'error';
}

const Alert = ({ children, heading, variant = 'info' }: AlertProps) => {
  const { theme } = useAppState();

  const variantConfig = {
    error: {
      color: theme.colors.alert,
      icon: <InfoCircleIcon color={theme.colors.alert} />,
    },
    info: {
      color: theme.colors.info,
      icon: <InfoCircleIcon color={theme.colors.info} />,
    },
  }[variant];

  return (
    <Container
      role={variant === 'error' ? 'alert' : 'status'}
      aria-live={variant === 'error' ? 'assertive' : 'polite'}
      aria-atomic="true"
    >
      <IconContainer aria-hidden="true">{variantConfig.icon}</IconContainer>
      <div>
        <Header variantColor={variantConfig.color}>{heading}</Header>
        {children}
      </div>
    </Container>
  );
};

export default Alert;
